const t = {
  Summary: "SUMMARY",
  Detailed: "DETAILED"
};
export {
  t
};
//# sourceMappingURL=Projection-c529eb70.mjs.map
